interface Props {
    title: string;
    subTitle: string;
}

export default function PolicyTabHeader({ title, subTitle }: Props) {
    return (
        <div className="border-b border-[#c7e0f3] bg-[#eef6fc] px-3 py-2.5 sm:px-4">
            <h2 className="text-xs font-semibold text-[#186cb2]">
                {title}
            </h2>
            <p className="mt-0.5 text-xs text-gray-600">
                {subTitle}
            </p>
        </div>
    )
}
